import axios from 'axios'

import { ERROR_MESSAGE_DELETING, ERROR_MESSAGE_SAVING } from '../constants'
import { handleRequestError } from './request'

export const RECEIVE_YOUNGER_DEPENDENTS = 'RECEIVE_YOUNGER_DEPENDENTS'
export const REQUEST_YOUNGER_DEPENDENTS = 'REQUEST_YOUNGER_DEPENDENTS'
const CREATE_YOUNGER_DEPENDENT = 'CREATE_YOUNGER_DEPENDENT'
const SAVE_YOUNGER_DEPENDENT = 'SAVE_YOUNGER_DEPENDENT'
const REMOVE_AND_DELETE_YOUNGER_DEPENDENT = 'REMOVE_AND_DELETE_YOUNGER_DEPENDENT'
export const REMOVE_YOUNGER_DEPENDENT = 'REMOVE_YOUNGER_DEPENDENT'
const DELETE_YOUNGER_DEPENDENT = 'DELETE_YOUNGER_DEPENDENT'

export const requestYoungerDependents = () => (dispatch, getState) => {
    dispatch({ type: REQUEST_YOUNGER_DEPENDENTS })

    const { profile } = getState()

    const { id: userId } = profile

    axios
        .get(`/youngerdependents/?userId=${userId}`)
        .then((response) => {
            const items = response?.data || []
            dispatch(receiveYoungerDependents({ items, fetchSuccessful: true }))
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveYoungerDependents({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveYoungerDependents({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

const receiveYoungerDependents = (data) => ({ type: RECEIVE_YOUNGER_DEPENDENTS, data })

export const createYoungerDependent = (data) => (dispatch, getState) => {
    dispatch({ type: CREATE_YOUNGER_DEPENDENT, data })

    const { id: userId } = getState().profile

    return axios
        .post(`/youngerdependents`, { ...data, userId })
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveYoungerDependents({ items: [responseData] }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const saveYoungerDependents = (data) => (dispatch, getState) => {
    dispatch({ type: SAVE_YOUNGER_DEPENDENT, data })

    const { id: userId } = getState().profile

    const { id } = data

    return axios
        .put(`/youngerdependents/${id}`, { ...data, userId })
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveYoungerDependents({ items: [responseData] }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const removeAndDeleteYoungerDependent = (data) => (dispatch) => {
    dispatch({ type: REMOVE_AND_DELETE_YOUNGER_DEPENDENT, data })

    dispatch(removeYoungerDependent(data))
    return dispatch(deleteYoungerDependent(data))
}

const removeYoungerDependent = (data) => ({ type: REMOVE_YOUNGER_DEPENDENT, data })

const deleteYoungerDependent = (data) => (dispatch) => {
    dispatch({ type: DELETE_YOUNGER_DEPENDENT, data })

    const { id } = data

    return axios
        .delete(`/youngerdependents/${id}`)
        .then(() => {
            dispatch(removeYoungerDependent({ id }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DELETING }))
        })
}
